import { render, staticRenderFns } from "./base-checkbox.vue?vue&type=template&id=2172f70e&scoped=true"
import script from "./base-checkbox.vue?vue&type=script&lang=ts"
export * from "./base-checkbox.vue?vue&type=script&lang=ts"
import style0 from "./base-checkbox.vue?vue&type=style&index=0&id=2172f70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2172f70e",
  null
  
)

export default component.exports